import { Region } from "./region";
import { DocumentSegment } from "./documentSegment";


export class Job {
  clientCode?:string;
  clientReferenceNum?:string;
  code?:string;
  completedById?:number;
  completedDate?:number;
  containslicencedcontent?:boolean;
  createdById?:number;
  createdDate?:number;
  deletednumber?:number;
  descr?:string;
  endDate?:number;
  externalUrl?:string;
  groupName?:string;
  id:number;
  isMarketingContent?:boolean;
  lastUpnumberdDate?:number;
  locale?:string;
  name?:string;
  searchIndex?:string;
  seqCode?:string;
  startDate?:number;
  statFlag?:string;
  statRunTrigger?:number;
  statisticsId?:number;
  subType?:string;
  uuid:string;
  xml?:string;
  campaignRegions?:Region[];
  documentSegments?:DocumentSegment[];
  pageOfferCount?:any;
  lockStatus?:string;
  lockTValues?:any[] = [];
  lockFValues?:any[] = [];


  get isLocked():boolean{
    return this.lockStatus === "T"?true:false;
  }
  get canLock():boolean{
    var status = true;
    if(this.documentSegments && this.documentSegments.length){
      for(let ds of this.documentSegments){
        if(ds.validationErrors && ds.validationErrors.pmValidations.length){
          status = false;
          break;
        }
      }
    }

    return status;
  }
}

export class JobMenuEvent{
  type?:string;
  job?:Job;
}

export const JobMenuEventType = {
  EDIT_JOB: 'EDIT_JOB',
  ADD_JOB: 'ADD_JOB',
  DELETE_JOB:'DELETE_JOB',
  NOTIFY_TEAMS:'NOTIFY_TEAMS_JOB',
  APPLY_TEAMS:'APPLY_TEAMS_JOB',
  APPLY_STUDIOS:'APPLY_STUDIOS_JOB',
  SEND_TO_STUDIO:'SEND_TO_STUDIO_JOB',
  COPY_JOB:'COPY_JOB',
  COPY_FULL_JOB:'COPY_FULL_JOB',
  ASSIGN_PAGE_TEMPLATE_TO_JOB:'ASSIGN_PAGE_TEMPLATE_TO_JOB',
  VIEW_SALES_SUMMARY:'VIEW_SALES_SUMMARY',
  ADD_PAGES:'ADD_PAGES_TO_JOB',
  CHANGE_MASTER_TEMPLATE:'CHANGE_MASTER_TEMPLATE',
  LOCK_JOB:'LOCK_JOB',
  SELECT_JOB:'SELECT_JOB',
  GENERATE_REPORT:'GENERATE_REPORT_JOB',
  DISPLAY_REPORTS:'DISPLAY_REPORTS_JOB',
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/job.ts